import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {KommissionierungBewegung} from "../../types/kommissionierung";
import {Palette} from "../../types/palette";

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-artikel-header',
    imports: [CommonModule,
    TranslatePipe],
    templateUrl: './artikel-header.component.html',
    styleUrls: ['./artikel-header.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArtikelHeaderComponent {
  @Input({ required: true }) bewegung!: KommissionierungBewegung;
  @Input() palette?: Palette | null;
  @Input() paletteAendern? = false;
  @Input() paletteEinzelEingabe? = false;
}
